import React from "react";
import { ReadOnlyStepProps } from "../useStepEditor";
import { Input, Stack, Title } from "@introist/react-foundation/v2";
import { TagAwareInput } from "modules/flows/components/TagAwareInput";
import { useAutomationStep } from "../../../automations/hooks/useAutomationStep";
import { Block } from "../../../../components/atoms";
import { StepEditorAccordion } from "../../../workflows/routes/WorkflowEditor/StepEditorAccordion";
import { DataSourceIcon } from "modules/datasources/components/DataSourceIcon";

export const HibobWorkEntryStepViewer = ({ stepId }: ReadOnlyStepProps) => {
  const { step } = useAutomationStep({ id: stepId });

  if (!step) return <div />;

  const stepData = step.stepData as any;
  const resolvedData = step.resolvedData as any;

  // Use resolved values if available, fallback to step data
  const datasourceName = resolvedData?.datasourceName || "HiBob";
  const effectiveDate = resolvedData?.resolvedEffectiveDate || stepData?.effectiveDate;
  const reason = resolvedData?.resolvedReason || stepData?.reason;
  const department = resolvedData?.resolvedDepartment || stepData?.department;
  const reportsTo = resolvedData?.resolvedReportsTo || stepData?.reportsTo;

  return (
    <>
      {/* Connection Section */}
      <Block blended compact>
        <StepEditorAccordion title="Connection" defaultOpen={false}>
          <StepEditorAccordion.Row label="HiBob Datasource">
            <Stack>
              <DataSourceIcon dataSource="hibob" size="small" />
              <Title variant="bold">{datasourceName}</Title>
            </Stack>
          </StepEditorAccordion.Row>
        </StepEditorAccordion>
      </Block>

      {/* Work Entry Details Section */}
      <Block blended compact>
        <StepEditorAccordion title="Work Entry Details" defaultOpen>
          <StepEditorAccordion.Row label="Effective Date">
            <Input
              value={effectiveDate || "Not set"}
              size="small"
              variant="blended"
              readOnly
              style={{ background: "var(--palette-surface-subdued)" }}
            />
          </StepEditorAccordion.Row>

          <StepEditorAccordion.Row label="Reason for Change">
            <TagAwareInput
              value={reason || "Not set"}
              size="small"
              variant="blended"
              readOnly
              onChange={() => {}}
              style={{ background: "var(--palette-surface-subdued)" }}
            />
          </StepEditorAccordion.Row>
        </StepEditorAccordion>
      </Block>

      {/* Optional Fields Section */}
      {(department || reportsTo) && (
        <Block blended compact>
          <StepEditorAccordion title="Optional Updates" defaultOpen>
            {department && (
              <StepEditorAccordion.Row label="Department">
                <Input
                  value={department}
                  size="small"
                  variant="blended"
                  readOnly
                  style={{ background: "var(--palette-surface-subdued)" }}
                />
              </StepEditorAccordion.Row>
            )}

            {reportsTo && (
              <StepEditorAccordion.Row label="Reports To">
                <Input
                  value={reportsTo}
                  size="small"
                  variant="blended"
                  readOnly
                  style={{ background: "var(--palette-surface-subdued)" }}
                />
              </StepEditorAccordion.Row>
            )}
          </StepEditorAccordion>
        </Block>
      )}
    </>
  );
};
